import React from "react";

const RegistrationFormHeading = () => (
  <div className="registration-form-heading">
    <h3 className="registration-form-heading__title">Formular</h3>
    <p className="registration-form-heading__subtitle">de înscriere</p>
  </div>
);

export default RegistrationFormHeading;
